<template>
	<div class="daily-gift" :class="{ disabled: !isAviable }" @click="dailyBonusClaim()">
		<ActivityIcon :icon="giftSvg" class="daily-gift-icon" />

		<div class="middle">
			<CrystalAmount :amount="settings.data.value?.dailyGift.amount || 0" class="crystal-amount" />
			Each day brigs you more points
		</div>

		<div v-if="!isAviable" class="time-left">{{ timeLeftString }}</div>

		<BaseButton v-else class="daily-gift-button">
			<ChevronRightIcon />
		</BaseButton>
	</div>
</template>

<script setup lang="tsx">
import giftSvg from '@/assets/images/gift.svg?url';
import ChevronRightIcon from '@/assets/icons/chevron-right.svg?component';
import ActivityIcon from './ActivityIcon.vue';
import CrystalAmount from './CrystalAmount.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import { msToTimeLeft } from '@/utils/time';
import { useDailyBonusClaim } from '../hooks/useDailyBonus';
import { useSettings } from '../hooks/useSettings';
import { useUser } from '../hooks/useUser';
import { computed } from 'vue';
import { ref } from 'vue';

const { mutate: dailyBonusClaim } = useDailyBonusClaim();
const settings = useSettings();
const user = useUser();

const dateNow = ref(Date.now());

const timeLeft = computed(() =>
	user.data.value && settings.data.value
		? new Date(user.data.value.dailyGift.lastClaim).getTime() +
		  settings.data.value.dailyGift.coldawn -
		  dateNow.value
		: undefined
);

const timeLeftString = computed(() => msToTimeLeft(timeLeft.value || 0));

setInterval(() => {
	dateNow.value = Date.now();
}, 1000);

const isAviable = computed(() => timeLeft.value && timeLeft.value < 0);
</script>

<style scoped>
.daily-gift {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.1) -1.65%,
		rgba(185, 218, 255, 0.1) 52.48%,
		rgba(2, 122, 255, 0.1) 104.15%
	);
	box-shadow: 0px 0px 25px rgba(2, 122, 255, 0.15);
	border-radius: 16px;

	font-style: normal;
	font-weight: 300;
	font-size: 13px;
	line-height: 16px;

	color: rgba(255, 255, 255, 0.7);

	border: 1px solid rgba(255, 255, 255, 0.03);

	cursor: pointer;
}

.daily-gift-button {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 12px;
	gap: 10px;

	width: 40px;
	height: 40px;

	background: linear-gradient(180deg, #0084ff 0%, #002b4b 100%);
	box-shadow: 0px 8px 12px rgba(2, 122, 255, 0.15), inset -8px -8px 12px rgba(0, 0, 0, 0.1),
		inset 8px 8px 12px rgba(255, 255, 255, 0.25);
	border-radius: 16px;

	stroke-opacity: 1 !important;
	stroke: #ffffff;
}

.middle {
	flex: 1;
}

.disabled {
	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.1) -1.65%,
		rgba(185, 218, 255, 0.1) 52.48%,
		rgba(2, 122, 255, 0.1) 104.15%
	);
	box-shadow: 0px 0px 25px rgba(2, 122, 255, 0.15);

	cursor: default;
	pointer-events: none;
}

.disabled .daily-gift-icon {
	opacity: 0.4;
	filter: saturate(0);
}

.disabled .crystal-amount {
	color: rgba(255, 255, 255, 0.5);
}

.time-left {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 6px 8px;
	gap: 6px;

	background: rgba(255, 255, 255, 0.05);
	border-radius: 16px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 16px;

	color: rgba(255, 255, 255, 0.6);
}
</style>
